// extracted by mini-css-extract-plugin
export default {"root":"PageCongratulations_root__Z-MBZ","inner":"PageCongratulations_inner__SHnIk","back":"PageCongratulations_back__temAr","content":"PageCongratulations_content__JSoR1"};